import { g as t } from "./global.js";
import { f as n } from "./function-uncurry-this.js";
import { d as e } from "./descriptors.js";
import { a as r } from "./array-buffer-basic-detection.js";
import { f as o } from "./function-name.js";
import { c as i } from "./create-non-enumerable-property.js";
import { d as s } from "./define-built-in-accessor.js";
import { d as f } from "./define-built-ins.js";
import { f as a } from "./fails.js";
import { a as u } from "./an-instance.js";
import { t as h } from "./to-integer-or-infinity.js";
import { t as c } from "./to-length.js";
import { t as g } from "./to-index.js";
import { i as m } from "./ieee754.js";
import { o as p } from "./object-get-prototype-of.js";
import { o as y } from "./object-set-prototype-of.js";
import "./object-get-own-property-names.js";
import { a as l } from "./array-fill.js";
import { a as b } from "./array-slice-simple.js";
import { s as j } from "./set-to-string-tag.js";
import { i as v } from "./internal-state.js";
import { __exports as w } from "../../../_virtual/object-get-own-property-names.js";
var I = w.f,
  d = o.PROPER,
  L = o.CONFIGURABLE,
  O = "ArrayBuffer",
  U = "DataView",
  F = "prototype",
  x = "Wrong index",
  A = v.getterFor(O),
  B = v.getterFor(U),
  R = v.set,
  E = t[O],
  N = E,
  W = N && N[F],
  _ = t[U],
  k = _ && _[F],
  D = Object.prototype,
  P = t.Array,
  V = t.RangeError,
  C = n(l),
  G = n([].reverse),
  q = m.pack,
  z = m.unpack,
  H = function H(t) {
    return [255 & t];
  },
  J = function J(t) {
    return [255 & t, t >> 8 & 255];
  },
  K = function K(t) {
    return [255 & t, t >> 8 & 255, t >> 16 & 255, t >> 24 & 255];
  },
  M = function M(t) {
    return t[3] << 24 | t[2] << 16 | t[1] << 8 | t[0];
  },
  Q = function Q(t) {
    return q(t, 23, 4);
  },
  S = function S(t) {
    return q(t, 52, 8);
  },
  T = function T(t, n, e) {
    s(t[F], n, {
      configurable: !0,
      get: function get() {
        return e(this)[n];
      }
    });
  },
  X = function X(t, n, e, r) {
    var o = B(t),
      i = g(e);
    if (i + n > o.byteLength) throw V(x);
    var s = o.bytes,
      f = i + o.byteOffset,
      a = b(s, f, f + n);
    return r ? a : G(a);
  },
  Y = function Y(t, n, e, r, o, i) {
    var s = B(t),
      f = g(e),
      a = r(+o),
      u = !!i;
    if (f + n > s.byteLength) throw V(x);
    for (var h = s.bytes, c = f + s.byteOffset, m = 0; m < n; m++) h[c + m] = a[u ? m : n - m - 1];
  };
if (r) {
  var Z = d && E.name !== O;
  if (!a(function () {
    E(1);
  }) || !a(function () {
    new E(-1);
  }) || a(function () {
    return new E(), new E(1.5), new E(NaN), 1 != E.length || Z && !L;
  })) {
    (N = function N(t) {
      return u(this, W), new E(g(t));
    })[F] = W;
    for (var $, tt = I(E), tn = 0; tt.length > tn;) ($ = tt[tn++]) in N || i(N, $, E[$]);
    W.constructor = N;
  } else Z && L && i(E, "name", O);
  y && p(k) !== D && y(k, D);
  var te = new _(new N(2)),
    tr = n(k.setInt8);
  te.setInt8(0, 2147483648), te.setInt8(1, 2147483649), (te.getInt8(0) || !te.getInt8(1)) && f(k, {
    setInt8: function setInt8(t, n) {
      tr(this, t, n << 24 >> 24);
    },
    setUint8: function setUint8(t, n) {
      tr(this, t, n << 24 >> 24);
    }
  }, {
    unsafe: !0
  });
} else W = (N = function N(t) {
  u(this, W);
  var n = g(t);
  R(this, {
    type: O,
    bytes: C(P(n), 0),
    byteLength: n
  }), e || (this.byteLength = n, this.detached = !1);
})[F], k = (_ = function _(t, n, r) {
  u(this, k), u(t, W);
  var o = A(t),
    i = o.byteLength,
    s = h(n);
  if (s < 0 || s > i) throw V("Wrong offset");
  if (r = void 0 === r ? i - s : c(r), s + r > i) throw V("Wrong length");
  R(this, {
    type: U,
    buffer: t,
    byteLength: r,
    byteOffset: s,
    bytes: o.bytes
  }), e || (this.buffer = t, this.byteLength = r, this.byteOffset = s);
})[F], e && (T(N, "byteLength", A), T(_, "buffer", B), T(_, "byteLength", B), T(_, "byteOffset", B)), f(k, {
  getInt8: function getInt8(t) {
    return X(this, 1, t)[0] << 24 >> 24;
  },
  getUint8: function getUint8(t) {
    return X(this, 1, t)[0];
  },
  getInt16: function getInt16(t) {
    var n = X(this, 2, t, arguments.length > 1 && arguments[1]);
    return (n[1] << 8 | n[0]) << 16 >> 16;
  },
  getUint16: function getUint16(t) {
    var n = X(this, 2, t, arguments.length > 1 && arguments[1]);
    return n[1] << 8 | n[0];
  },
  getInt32: function getInt32(t) {
    return M(X(this, 4, t, arguments.length > 1 && arguments[1]));
  },
  getUint32: function getUint32(t) {
    return M(X(this, 4, t, arguments.length > 1 && arguments[1])) >>> 0;
  },
  getFloat32: function getFloat32(t) {
    return z(X(this, 4, t, arguments.length > 1 && arguments[1]), 23);
  },
  getFloat64: function getFloat64(t) {
    return z(X(this, 8, t, arguments.length > 1 && arguments[1]), 52);
  },
  setInt8: function setInt8(t, n) {
    Y(this, 1, t, H, n);
  },
  setUint8: function setUint8(t, n) {
    Y(this, 1, t, H, n);
  },
  setInt16: function setInt16(t, n) {
    Y(this, 2, t, J, n, arguments.length > 2 && arguments[2]);
  },
  setUint16: function setUint16(t, n) {
    Y(this, 2, t, J, n, arguments.length > 2 && arguments[2]);
  },
  setInt32: function setInt32(t, n) {
    Y(this, 4, t, K, n, arguments.length > 2 && arguments[2]);
  },
  setUint32: function setUint32(t, n) {
    Y(this, 4, t, K, n, arguments.length > 2 && arguments[2]);
  },
  setFloat32: function setFloat32(t, n) {
    Y(this, 4, t, Q, n, arguments.length > 2 && arguments[2]);
  },
  setFloat64: function setFloat64(t, n) {
    Y(this, 8, t, S, n, arguments.length > 2 && arguments[2]);
  }
});
j(N, O), j(_, U);
var to = {
  ArrayBuffer: N,
  DataView: _
};
export { to as a };